import React from 'react';

import { LegacyBox, styled } from '@gogame/components';

import { getActivityTypeColor } from 'scenes/MarketingPlanning/MarketingPlanningWizard/constants';

const Container = styled(LegacyBox)`
  width: 4px;
`;

const Indicator = styled(LegacyBox)`
  background: ${({ type, theme }) => getActivityTypeColor(type, theme)};
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 4px;
`;

export const ActivityTypesIndicator = ({ type }) => (
  <Container>
    <Indicator type={type} />
  </Container>
);
